
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
name: "setting",
components: {
Cell,
Group,
},
data() {
return {
isLogin: false,
userId: "",
lang: "zh-hk",
newsSwitch: "",
user: {},
};
},
methods: {

onClickLeft(){
try {
this.$router.back()
let isIos = /iPad|iPhone|iPod|ios/.test(navigator.userAgent) && !window.MSStream;
if(isIos){
window.webkit.messageHandlers.onExitPage.postMessage({"page":"about"});
}else{
window.AndroidInterface.onExitPage()
}
} catch (error) {
console.log(error)
}
},

changeLang() {
let lang = "zh-hk";
if (this.lang == "zh-cn") {
lang = "zh-hk";
this.$toast.text("繁體設置成功,重啓生效");

} else {
lang = "zh-cn";
this.$toast.text("简体设置成功,重启生效");

}

this.lang = lang;
let test = {
key: "lang",
value: JSON.stringify({
type: false,
lang: lang,
}),
};



},

gotopage(obj) {
this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
},

returnLogin() {
this.$toast.loading();
this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.USER.LOGOUT, {}, "POST","no login")
.then(res => {
console.log('退出',res)
this.isLogin = false
this.$toast.close();
this.LOGIN.returnLogin();
setTimeout(() => {
this.$router.push({
path: '/my'
});
}, 1000);

})
.catch(err => {
console.log(err);
});
},
},
mounted() {
this.LOGIN2.getSession("no login")
.then((session) => {
console.log("session----", session);
if (session != "") {
this.isLogin = true;
} else {
this.isLogin = false;
}
})
.catch((err) => {

this.isLogin = false;
});
},
};



// WEBPACK FOOTER //
// ./src/pages/me/setting/setting.vue